import { useCallback, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useMount } from '../../../hooks/useMount';
import { talentOnboardingCompleteStep } from '../../../redux/actions/talentOnboardingActions';
import { events } from '../helpers';

export const useTrackEvent = ({ current, network, steps }) => {
  const dispatch = useDispatch();
  const trackedEvents = useRef({});

  const handleEvent = useCallback(() => {
    const step = steps[current];
    const event = events[step.id];

    if (!trackedEvents.current[event.name]) {
      trackedEvents.current[event.name] = true;
      dispatch(
        talentOnboardingCompleteStep({
          eventName: event.name,
          step: event.step,
          network,
        }),
      );
    }
  }, [steps, current, dispatch, network]);

  useMount(handleEvent);
};
